import * as React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { useDispatch } from 'react-redux';
import { useTranslator } from '@gandi/translate';
import { getDisplayName } from 'gandi.react-helpers';
import { usePageMeta } from './hooks/usePageMeta';
import { jsx as _jsx } from "react/jsx-runtime";
export const withPageMeta = metaFunc => WrappedComponent => {
  function WithPageMeta(props) {
    const translator = useTranslator();
    const dispatch = useDispatch();
    const args = {
      dispatch,
      ...translator,
      ...props
    };
    const pageMeta = metaFunc(args);
    usePageMeta(pageMeta);
    return /*#__PURE__*/_jsx(WrappedComponent, {
      ...props
    });
  }
  WithPageMeta.handlePageMeta = args => {
    const {
      basename,
      match,
      params,
      query,
      redirect,
      getState,
      subscribe,
      req,
      res,
      replaceReducer,
      translator,
      ...props
    } = args;
    return metaFunc({
      ...translator,
      ...props
    });
  };
  const HoistedComponent = hoistNonReactStatic(WithPageMeta, WrappedComponent);
  HoistedComponent.displayName = `WithPageMeta(${getDisplayName(WrappedComponent)})`;
  return HoistedComponent;
};